import { apiRequest } from "./service";
import {
  PREORDERS, PREORDER_BY_ID, PREORDER_CANCEL, PREORDER_CONFIRM, PREORDER_CONSENTS,
  PREORDER_CONSENT_WITHDRAW, PREORDER_LEGAL, PREORDER_PAY, PREORDER_PRODUCT, PREORDER_PRODUCTS, PREORDER_ADDRESS,
} from "./apiUrl";

/**
 * Pre-order API calls.
 *
 * The first three are public — `isPublic: true` keeps the token off the
 * request and stops the 401 interceptor trying to refresh a session the
 * visitor does not have yet.
 */

export const getPreorderProductsApi = () =>
  apiRequest({ apiUrl: PREORDER_PRODUCTS, method: "GET", isPublic: true });

export const getPreorderProductApi = (slug) =>
  apiRequest({ apiUrl: PREORDER_PRODUCT(slug), method: "GET", isPublic: true });

export const getPreorderLegalApi = () =>
  apiRequest({ apiUrl: PREORDER_LEGAL, method: "GET", isPublic: true });

// Creates the order and returns whatever Razorpay needs to open its checkout.
// No amount is sent: the server prices it from the product.
export const createPreorderApi = ({ token, slug, paymentPlan, qty, contact, shippingAddress, consents, attribution }) =>
  apiRequest({
    apiUrl: PREORDERS,
    method: "POST",
    token,
    payload: { slug, paymentPlan, qty, contact, shippingAddress, consents, attribution },
  });

// Hands back what Razorpay's checkout returned, for the server to verify.
export const confirmPreorderPaymentApi = ({ token, razorpay_order_id, razorpay_payment_id, razorpay_signature }) =>
  apiRequest({
    apiUrl: PREORDER_CONFIRM,
    method: "POST",
    token,
    payload: { razorpay_order_id, razorpay_payment_id, razorpay_signature },
  });

export const getMyPreordersApi = ({ token }) =>
  apiRequest({ apiUrl: PREORDERS, method: "GET", token });

export const getMyPreorderApi = ({ token, id }) =>
  apiRequest({ apiUrl: PREORDER_BY_ID(id), method: "GET", token });

// Raises a payment link for whatever is still owed.
export const payPreorderBalanceApi = ({ token, id }) =>
  apiRequest({ apiUrl: PREORDER_PAY(id), method: "POST", token, payload: {} });

// Sets the delivery address on an order. Not asked for at reservation time,
// so this is how it arrives before dispatch.
export const setPreorderAddressApi = ({ token, id, shippingAddress }) =>
  apiRequest({ apiUrl: PREORDER_ADDRESS(id), method: "POST", token, payload: { shippingAddress } });

export const cancelPreorderApi = ({ token, id, reason }) =>
  apiRequest({ apiUrl: PREORDER_CANCEL(id), method: "POST", token, payload: { reason } });

export const getMyConsentsApi = ({ token }) =>
  apiRequest({ apiUrl: PREORDER_CONSENTS, method: "GET", token });

export const withdrawConsentApi = ({ token, purpose }) =>
  apiRequest({ apiUrl: PREORDER_CONSENT_WITHDRAW, method: "POST", token, payload: { purpose } });
